import { Typography } from '@breetometer/components';
import { InfoIcon } from 'BreetAssets';
import { Dropdown, Tooltip, TooltipContent } from 'BreetComponents';
import type { ICurrencyDropDownItem } from 'BreetHelpers';
import { useWalletBalance } from 'BreetHooks';
import { selectFiatMeta, useAppSelector } from 'BreetRedux';
import { type MouseEvent, useCallback } from 'react';

import type { ISelectWallet } from './SelectWallet.helpers';

const SelectWallet = ({ selectWallet, selectedWallet, title, toolTip }: ISelectWallet) => {
	const { getBalance } = useWalletBalance();

	const fiatMeta = useAppSelector(selectFiatMeta);

	const defaultSelectedWallet: ICurrencyDropDownItem = {
		currency: fiatMeta.currency,
		walletBalance: getBalance(fiatMeta.currency),
	};

	const handleItemSelect = useCallback(
		(item: ICurrencyDropDownItem) => (e: MouseEvent<HTMLButtonElement>) => {
			e.stopPropagation();
			selectWallet?.(item);
		},
		[selectWallet]
	);

	return (
		<div className='select-wallet-container'>
			<div className='header label-tooltip-header'>
				<Typography className='color-primary-100'>{title}</Typography>
				{toolTip && (
					<Tooltip tipElement={<TooltipContent content={toolTip} />}>
						<InfoIcon className='info-icon svg-dark' />
					</Tooltip>
				)}
			</div>
			<div className='select-wallet'>
				<Dropdown.Currency
					items={[
						{
							currency: fiatMeta.currency,
							walletBalance: getBalance(fiatMeta.currency),
						},
						{
							currency: 'USD',
							walletBalance: getBalance('USD'),
						},
					]}
					placeholder='Select Wallet'
					label=''
					hideSearch
					id='select-wallet-balance'
					selectedItem={selectedWallet ?? defaultSelectedWallet}
					handleItemSelect={handleItemSelect}
				/>
			</div>
		</div>
	);
};

export default SelectWallet;
